var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},[_c('ul',_vm._l((_vm.$store.state.languages),function(lan){return _c('li',{on:{"click":function($event){return _vm.selectLang(lan.value)}}},[_vm._v("\n     "+_vm._s(lan.label)+"\n   ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }